import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage, GatsbyImageProps } from "gatsby-plugin-image"

const query = graphql`
  query {
    img: file(relativePath: { eq: "LowerBanner/halva.png" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
      }
    }
  }
`

export default function ImgHalva(props: Omit<GatsbyImageProps, "image">) {
  const data = useStaticQuery(query)

  return <GatsbyImage {...props} image={getImage(data.img)!} />
}
